export default __webpack_public_path__ + "static/media/ru-store-white.0dd70733.svg";